import React from "react";
import Section from "../components/Section";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <main className="min-h-screen">
      <Section id="contact" title="Contact" eyebrow="signal path">
        <p className="mb-6 text-sm md:text-base text-text-muted max-w-2xl">
          I’m best suited for automation-heavy internal tools, dashboards, and security-conscious web apps. Share a bit about what you’re building and I’ll let you know quickly if I’m a good fit.
        </p>
        <div className="grid gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.2fr)] items-start">
          <div className="space-y-6 text-text-muted">
            <p className="text-base leading-relaxed">
              I respond fastest to thoughtful briefs about secure automation, high-signal dashboards, and AI/agent systems that augment teams. Share as much context as you can and we’ll spin up a working session quickly.
            </p>
            <ul className="space-y-3 text-sm">
              <li className="border-l-2 border-accent pl-4">
                <span className="font-mono uppercase text-xs block text-text-subtle">Response SLA</span>
                <span>Typically within 24 hours, sooner for production issues.</span>
              </li>
              <li className="border-l-2 border-accent pl-4">
                <span className="font-mono uppercase text-xs block text-text-subtle">Signals I’m tracking</span>
                <span>Agent copilots, observability, automation frameworks, and security tooling.</span>
              </li>
              <li className="border-l-2 border-accent pl-4">
                <span className="font-mono uppercase text-xs block text-text-subtle">Direct line</span>
                <a href="mailto:contact@enkae.dev" className="text-accent hover:text-primary transition">
                  contact@enkae.dev
                </a>
              </li>
            </ul>
          </div>
          <ContactForm />
        </div>
      </Section>
    </main>
  );
}
